import { useTranslation } from 'libs/i18n';
import { Stack, Typography } from 'libs/ui';
import {
  Field,
  useFormContext,
  TargetedFinancialInstrumentsFormType,
} from 'modules/onboarding/legal/forms/targetedFinancialInstrumentsForm';

interface Props {
  type: keyof TargetedFinancialInstrumentsFormType['financialInstruments'];
}

const Section = ({ type }: Props) => {
  const { t } = useTranslation();

  const { values } = useFormContext();

  return (
    <>
      <Stack direction="row" justifyContent="space-between" spacing={16}>
        <Typography variant="subtitle1" variantMobile="captionBold">
          {t(
            `onboarding.targetedFinancialInstruments.financialInstruments.${type}.title`
          )}
        </Typography>
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          spacing={16}
        >
          <Typography
            variant="bodyMedium"
            variantMobile="caption"
            whiteSpace="nowrap"
          >
            {t('common.choose')}
          </Typography>
          <Field.Switch name={`financialInstruments.${type}.enabled`} />
        </Stack>
      </Stack>

      {values.financialInstruments?.[type]?.enabled && (
        <>
          <Field.Price
            fullWidth
            showOptionalMark
            label={t(
              `onboarding.targetedFinancialInstruments.financialInstruments.fields.monthlyTradeAmount.label`
            )}
            name={`financialInstruments.${type}.monthlyTradeAmount`}
            placeholder={t(
              `onboarding.targetedFinancialInstruments.financialInstruments.fields.monthlyTradeAmount.placeholder`
            )}
          />
          <Field.Price
            fullWidth
            label={t(
              `onboarding.targetedFinancialInstruments.financialInstruments.fields.yearlyTradeAmount.label`
            )}
            name={`financialInstruments.${type}.yearlyTradeAmount`}
            placeholder={t(
              `onboarding.targetedFinancialInstruments.financialInstruments.fields.yearlyTradeAmount.placeholder`
            )}
          />
        </>
      )}
    </>
  );
};

export const FinancialInstrumentsFields = () => (
  <>
    <Section type="stocks" />
    <Section type="bonds" />
    <Section type="mutualFunds" />
    <Section type="derivatives" />
    <Section type="structuredProducts" />
    <Section type="otherFinancialInstruments" />
  </>
);
